import type { ReactNode } from "react"

import { cn } from "@productlane/lib/src/cn"

/**
 * `error` is a value the policy refuses to save; `muted` is guidance the author
 * can act on or ignore.
 */
export type NoticeTone = "error" | "muted"

export const NOTICE_TEXT: Record<NoticeTone, string> = {
	error: "text-red-600 dark:text-red-400",
	muted: "text-tertiary",
}

interface Props {
	children: ReactNode
	tone?: NoticeTone
	/** A button that applies the fix the notice describes. */
	action?: ReactNode
	className?: string
}

/** One row for everything a field has to say about its value, fix included. */
export function FieldNotice({
	children,
	tone = "muted",
	action,
	className,
}: Props) {
	return (
		<div
			className={cn(
				"mt-1.5 flex flex-wrap items-center gap-x-1.5 gap-y-1 text-xs",
				NOTICE_TEXT[tone],
				className,
			)}
		>
			<span>{children}</span>
			{action}
		</div>
	)
}
